import { Component, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from "../../../shared/components/modal/modal.component";

@Component({
  selector: 'aig-modal-message',
  imports: [ModalComponent],
  templateUrl: './modal-message.component.html',
  styleUrl: './modal-message.component.scss'
})
export class ModalMessageComponent {
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(): void {
    this.hideModal.emit(true);
  }

}
